module.exports = (__parcel__import__("jsOId")).then(() => parcelRequire('fyWP3'));